// extracted by mini-css-extract-plugin
export default {"items":"ZrlzH","waveform":"jMpCa"};